import React, { createContext, useContext } from 'react';
import { useGetSettingsQuery } from '../app/api';

const AppSettingsContext = createContext({
  settings: null,
  imageBaseUrl: '',
  loading: true,
  error: null,
});

export const useAppSettings = () => useContext(AppSettingsContext);

export const AppSettingsProvider = ({ children }) => {
  // ✅ RTK Query — API se imageBaseUrl aata hai
  const { data, isLoading, error } = useGetSettingsQuery();

  const value = {
    settings: data?.data?.settings || null,
    imageBaseUrl: data?.data?.imageBaseUrl || '',  // ✅ API se
    loading: isLoading,
    error,
  };

  return (
    <AppSettingsContext.Provider value={value}>
      {children}
    </AppSettingsContext.Provider>
  );
};